export const API = {
  // QUOTATION
  quotation: {
    // V1
    V1__FETCH__ALL: () => '/api/v1/quotation',
    V1__FETCH__BY_ID: id => `/api/v1/quotation/${id}`,
    V1__CREATE: () => '/api/v1/quotation',
    V1__PUT__BY_ID: id => `/api/v1/quotation/${id}`,
    V1__ACTION__CALCULATE: () => '/api/v1/portal/quotation/calculate',
    V1__ACTION__PRINT: () => '/api/v1/portal/quotation/print',
    V1__ACTION__VALIDATE: () => '/api/v1/portal/quotation/validate',
    V1__ACTION__SUBSCRIBE: () => '/api/v1/portal/quotation/subscribe',
    V1__ACTION__CALCULATE__BY_ID: id => `/api/v1/portal/quotation/calculate/${id}`,
    V1__ACTION__CANCEL__BY_ID: id => `/api/v1/quotation/${id}/cancel`,
    V1__ACTION__PENDING__BY_ID: id => `/api/v1/quotation/${id}/pend`,
    V1__ACTION__PRINT__BY_ID: id => `/api/v1/quotation/${id}/print`,
    V1__ACTION__SAVE__BY_ID: id => `/api/v1/quotation/${id}/save`,
    V1__ACTION__SUBSCRIBE__BY_ID: id => `/api/v1/portal/quotation/subscribe/${id}`,
    // V2
    V2_ACTION_VALIDATE  : () => '/api/v2/sales-route/actions/validate',
    V2_ACTION_PRINT  : () => '/api/v2/sales-route/actions/print'

  },
  // LOAN
  loan: {
    // V1
    V1__FETCH__MODEL_KIND: () => '/api/v1/loan/model/kind',
    V1__FETCH__MODEL_DEFERRAL: () => '/api/v1/loan/model/deferral',
  },
  // BANK
  bank: {
    // V1
    V1__FETCH__ALL: () => '/api/v1/bank',
    V1__ACTION__VALIDATE_IBAN: iban => `/api/v1/bank/bic/${iban}`,
  },
};
